import DateGrid from "components/DateFilter/DateGrid";
import {
  getFormattedDateForDashboard,
  getOneMonthAgoDate,
} from "global/helpers";
import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { useMutation } from "react-query";
import { getProfit } from "./DashboardServices";

const Profit = () => {
  const [startDate, setStartDate] = useState<Date>(getOneMonthAgoDate());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [dateCategory, setDateCategory] = useState(null);

  const [profits, setProfits] = useState<any>([
    {
      date: getFormattedDateForDashboard(),
      amount: 0.0,
    },
  ]);

  const mutate = useMutation(getProfit, {
    onSuccess(data) {
      setProfits(data);
    },
  });

  useEffect(() => {
    if (startDate || endDate) {
      mutate.mutate({ startDate: startDate, endDate: endDate });
    }
  }, [startDate, endDate]);

  let data = [["Year", "Amount in $"]];

  profits?.forEach((e) => {
    data?.push([e?.date, e?.amount]);
  });

  const options = {
    chart: {
      title: "Profits",
    },
  };

  return (
    <div className="row w-100">
      <DateGrid
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        dateCategory={dateCategory}
        setDateCategory={setDateCategory}
        isFullWidth={true}
        isForExpenses={true}
      />

      {data && (
        <Chart
          chartType="Bar"
          width="700px"
          height="350px"
          loader={<div>Loading Chart</div>}
          data={data}
          options={options}
        />
      )}
    </div>
  );
};

export default Profit;
